import React from 'react';
import styles from './authLoader.module.css';

export const AuthLoader = () => (
  <div className={styles.loaderWrapper}>
    <div className={styles.loader} />
  </div>
);
